import { type ReactElement, type ReactNode, useState, useEffect } from "react";
import Modal from "src/components/Modal";
import Button from "src/components/Button";

export interface MACSearchErrorModalProps {
        title: string,
        isOpen: boolean,
        errorMessage: string,
        onClose: () => void,
        children?: ReactNode
}

export default function MACSearchErrorModal(props: MACSearchErrorModalProps): ReactElement {
        return <>
                <Modal isOpen={props.isOpen} modalSize="md" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        < div className="flex flex-col gap-4">
                                <div className="flex justify-center">
                                        {props.errorMessage}
                                </div>
                                <div className="flex justify-center">
                                        <Button className="" size="lg" type="button" buttonStyle="primary" handleClick={props.onClose}>OK</Button>
                                </div>
                        </div>
                </Modal>
        </>
}
